import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { environment as configs } from 'src/environments/environment';
import { HttpClient, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from "../../common.service";
import { Location } from '@angular/common';
import * as $ from 'jquery';
var MakepaymentComponent = /** @class */ (function () {
    function MakepaymentComponent(location, httpClient, router, modalService, CSF, aroute) {
        var _this = this;
        this.location = location;
        this.httpClient = httpClient;
        this.router = router;
        this.modalService = modalService;
        this.CSF = CSF;
        this.aroute = aroute;
        this.offlinePay = 0;
        this.paymethod = 1;
        this.host = configs['ApiHost'];
        this.uploading = false;
        this.percentUpload = 0;
        this.ChallanId = '';
        this.filetypes = ['jpg', 'png', 'pdf'];
        this.payAction = 'https://pgi.billdesk.com/pgidsk/PGIMerchantPayment';
        //payAction="http://localhost:3000/testPayment"
        //payAction="http://bocw.punjab.gov.in/bocwapi/testPayment"
        this.isEnablePayment = false;
        this.busy = false;
        this.form27 = '';
        this.backButton = function (step) {
            _this.paymethod = 1;
        };
        // console.log(this.CSF.isUserLoggedIn(),"is logged in");
        if (this.CSF.isUserLoggedIn()) {
            this.CSF.setNavs(true);
        }
        else {
            this.CSF.setNavs(false);
        }
    }
    MakepaymentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userRole = (localStorage.user) ? JSON.parse(localStorage.getItem('user')).role.toString() : undefined;
        this.aroute.params.subscribe(function (i) {
            // console.log(i, 'params......')
            if (i.challanNo && i.challanNo !== "") {
                _this.challanNo = i.challanNo;
                _this.makepaymentonline();
            }
            //this.params = i;
        });
        // 211919229
        //
    };
    MakepaymentComponent.prototype.makepaymentonline = function () {
        this.paymethod = 0;
        this.offlinePay = 2;
        if (this.challanNo !== undefined && this.challanNo !== '') {
            this.verifyChallan();
        }
    };
    MakepaymentComponent.prototype.makepaymentoffline = function () {
        this.paymethod = 0;
        this.offlinePay = 1;
        if (this.challanNo !== undefined && this.challanNo !== '') {
            this.verifyChallan();
        }
        //this.paychannel =chennelDetail['data'];
    };
    MakepaymentComponent.prototype.verifyChallan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var challanInfo, challanDetail;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.challanNo == undefined || this.challanNo.length == 0)
                            return [2 /*return*/, false];
                        return [4 /*yield*/, this.httpClient.post(this.host + '/verify/challan', { challanNo: this.challanNo }, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()];
                    case 1:
                        challanInfo = _a.sent();
                        challanDetail = challanInfo['data'];
                        if (challanDetail && challanDetail.length > 0) {
                            this.ChallanId = challanDetail[0]['ChallanId'];
                            this.WrkName = challanDetail[0]['WorkerName'];
                            this.WrkYr = challanDetail[0]['Years'];
                            this.WrkMob = challanDetail[0]['MobileNo'];
                            this.fee = challanDetail[0]['Amount'];
                            this.WrkSerialCode = challanDetail[0]['WorkerSerialNo'];
                            this.challanValid = 1;
                            this.paymentType = challanDetail[0]['TypeOfPayment'];
                            this.isEnablePayment = true;
                        }
                        else {
                            this.challanValid = 0;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MakepaymentComponent.prototype.submitPaymentEntry = function (frm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = (this.paymentType == 1) ? 'newreg' : 'renewal';
                        return [4 /*yield*/, this.httpClient.post(this.host + '/payment/makePaymentEntry', { challanNo: this.ChallanId, type: type, form27: this.form27 }, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()];
                    case 1:
                        result = _a.sent();
                        // console.log(result);
                        if (result['status'] == true) {
                            this.payMsg = result['paymentMsg'];
                            //console.log(frm.toString())
                            frm.querySelector('#msg').value = this.payMsg;
                            // console.log(frm.querySelector('#msg').value)
                            frm.submit();
                        }
                        else {
                            // alert("something is wrong");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MakepaymentComponent.prototype.uploadFile = function (fileToUpload) {
        var _formData = new FormData();
        _formData.append('file', fileToUpload, fileToUpload.name);
        var reqs = new HttpRequest('POST', this.host + '/upload/image', _formData, {
            reportProgress: true,
        });
        // console.log(reqs)
        return this.httpClient.request(reqs);
    };
    MakepaymentComponent.prototype.fileEvent = function ($event, filetypes, fileModal) {
        var _this = this;
        // console.log($event.target.files[0])
        var fileSelected = $event.target.files[0];
        var temparr = fileSelected.name.split('.');
        var extfile = temparr[temparr.length - 1];
        if (filetypes.indexOf(extfile) > -1) {
            ////////////////////////// upload file ///////////////////////////
            this.uploading = true;
            var prog = this.uploadFile(fileSelected)
                .subscribe(function (response) {
                var event = response;
                if (event.type === HttpEventType.UploadProgress) {
                    // This is an upload progress event. Compute and show the % done:
                    var percentDone = Math.round(100 * event.loaded / event.total);
                    _this.percentUpload = percentDone;
                }
                else if (event instanceof HttpResponse) {
                    // console.log('file',response.body.filename)
                    if (fileModal == 'feerecipt') {
                        _this.feeReceipt = response.body.filename;
                    }
                    else {
                        _this.form27 = response.body.filename;
                    }
                    // console.log(this.form27,this.feeReceipt)
                    _this.uploading = false;
                    _this.percentUpload = 0;
                }
            });
            /////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////
            this.httpClient.request('GET', prog).subscribe(function (event) {
                // Via this API, you get access to the raw event stream.
                // Look for upload progress events.
                // if (event.type === HttpEventType.UploadProgress) {
                //   // This is an upload progress event. Compute and show the % done:
                //   const percentDone = Math.round(100 * event.loaded / event.total);
                // console.log(`File is ${percentDone}% uploaded.`);
                // } else if (event instanceof HttpResponse) {
                //   console.log('File is completely uploaded!');
                // }
            });
            /////////////////////////////////////////////////////////////////
        }
        else {
            /*  this.modalService.error({
                title: 'file type not valid. Should be one of following.',
                content: 'Only '+filetypes.join()+' file types are allowed',
                okText:'ok'
              });*/
            Swal.fire({
                type: 'error',
                title: 'file type not valid. Should be one of following.',
                text: 'Only ' + filetypes.join() + ' file types are allowed'
            });
        }
    };
    MakepaymentComponent.prototype.SubmitFeeDetails = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, paymentinfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.ChallanId != undefined && this.WrkSerialCode != undefined && this.feeReceipt != undefined)) return [3 /*break*/, 2];
                        type = (this.paymentType == 1) ? 'newreg' : 'renewal';
                        return [4 /*yield*/, this.httpClient.post(this.host + '/payment/challan ', { ChallanId: this.ChallanId, WrkSerialCode: this.WrkSerialCode, feeReceipt: this.feeReceipt, type: type, form27: this.form27 }, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()];
                    case 1:
                        paymentinfo = _a.sent();
                        // console.log(paymentinfo);
                        if (paymentinfo['status'] == true) {
                            /* this.modalService.success({
                               title: 'Fee Submitted Sucessfully',
                               content: 'Your File submited successfuly.',
                               okText:'ok'
                             });*/
                            Swal.fire({
                                type: 'success',
                                title: 'Fee Submitted Sucessfully',
                                text: 'Your File submited successfuly.'
                            });
                            this.router.navigate(['worker', 'register']);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        /*this.modalService.error({
                          title: 'Something is Wrong',
                          content: 'Please Upload Fee Receipt',
                          okText:'ok'
                        });*/
                        Swal.fire({
                            type: 'error',
                            title: 'Something is Wrong',
                            text: 'Please Upload Fee Receipt.'
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MakepaymentComponent.prototype.paycscfee = function () {
        $('#vlechallanid').val(this.challanNo);
        $('#vlepay').submit();
    };
    MakepaymentComponent.prototype.goBack = function () {
        // window.history.back();
        this.location.back();
        console.log('goBack()...');
    };
    return MakepaymentComponent;
}());
export { MakepaymentComponent };
